import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { PropTypes } from 'prop-types';

// Parametros props
//id: Id identificador del componente
//name: nombre identificador del componente
//items: opciones a elegir [{label: 'TI', title: 'TI'}]
//fn: Función que retorna los cambios del componente
//optiondisabled: opción que va estar deshabilitada 
//label: valor a mostrar una vez seleccionado
//placeholder: Etiqueta previa antes de seleccionar un registro

AutoComplete.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  items: PropTypes.array,
  fn: PropTypes.func,
  optiondisabled: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
};

AutoComplete.defaultProps = { 
  id: 'Custom',
  name: 'Custom',
  items: [{ label: '', title: '' }],
  fn: ()=>{ console.log("Seleccione un registro")},
  optiondisabled: '',
  label: "",
  placeholder: "",
  helperText: "",
  style: {},
  variant: "standard",
  error: false
}  

function AutoComplete(props) {
  return (
    <>
     <Autocomplete
          id={props.id}
          clearIcon={false}
          value={props.value}
          name={props.name}
          options={props.items}
          multiple={props.multiple}
          autoComplete={true}
          onChange={props.fn}
          disableclearable={{}}
          renderInput={(params) => (
            <TextField {...params } error={props.error} variant={props.variant} sx={{ "& .MuiButtonBase-root": { color: 'black' } }} value={props.value} style={props.style} label={props.Initial} placeholder={props.placeholder} helperText={props.helperText} endadornment={{}}/>
          )}
      />
    </>
  );
}

export default React.memo(AutoComplete);